import { Link } from "react-router-dom";

import thumbnailMap from "../../public/thumbnail-map2.jpg";

function BlogsMobile() {
  return (
    <section id="blog" className="pt-[95px]">
      <div className="container items-start">
        <div className="flex items-center">
          <p className="text-xl font-bold mb-4">WRITING</p>
        </div>

        <p className="text-gray-4">
          I occasionally write about programming, productivity, and more.
        </p>
        <p className="text-gray-4 mb-8">1 post so far. Stay tuned for more!</p>

        <a href="/blog/map" className="flex flex-row items-center gap-6">
          <div className="mb-4">
            <p className="text-[15px] text-gray-4">Apr 27, 2024</p>
            <p className="mt-2 w-auto font-normal">
              Picking a location with React Native using a performance-oriented
              approach like Grab, Uber, and others do
            </p>
          </div>

          <div className="h-24 w-24 min-w-24 overflow-hidden mb-6 mt-8 items-center justify-center rounded-md bg-secondary shadow-sm md:hidden">
            <img
              src={thumbnailMap}
              alt="thumbnail"
              className="object-cover w-full h-full"
            />
          </div>
        </a>
      </div>
    </section>
  );
}

export default BlogsMobile;
